export enum StatusType {
  Idle = 'idle',
  Loading = 'loading',
  Error = 'error',
  Success = 'success',
}
